import { Col, Row } from 'antd';
import { sourceIcon } from './sourceIcon';
import { FormInstance } from 'antd/es/form/Form';

type Props = {
    addFiles: (file: File) => void;
    form: FormInstance;
    handleSelect: () => void;
};

export const IconCandidate: React.FC<Props> = ({ form, addFiles, handleSelect }) => {
    const onSelect = (value: number) => {
        const record = sourceIcon.find((_, index) => index === value);

        if (record === undefined) return;

        form.resetFields(['files']);

        fetch(record.image.url)
            .then((response) => response.blob())
            .then((blob) => convertToFileFromBlob(blob, record.image.name))
            .then((file) => addFiles(file));

        handleSelect();
    };

    return (
        <Row gutter={[16, 16]} style={{ width: '500px' }}>
            {sourceIcon.map((item, index) => {
                return (
                    <Col
                        key={index}
                        span={8}
                        onClick={() => onSelect(index)}
                        style={{
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                        <img src={item.image.url} alt={item.image.name} />
                    </Col>
                );
            })}
        </Row>
    );
};

const convertToFileFromBlob = (blob: Blob, imageName: string) => {
    const newFileName = imageName.match(/(.jpg|.jpeg|.png|.gif|.bmp)$/)
        ? imageName
        : `${imageName}.${blob.type.split('image/')[1]}`;

    return new File([blob], newFileName);
};
